import {
	SELECTED_STORAGE,
	GET_SKU,
	SELECTED_COLOR,
} from '../actionTypes/index';

const initialState = {
	color: {},
	storage: '',
	sku: '',
	bundleProducts: [],
};

export default (state = initialState, { type, payload }) => {
	switch (type) {
		case SELECTED_COLOR:
			return {
				...state,
				color: payload,
			};

		case SELECTED_STORAGE:
			return {
				...state,
				storage: payload,
			};
		case GET_SKU:
			return {
				...state,
				sku: payload,
			};
		default:
			return state;
	}
};
